module.exports = __webpack_public_path__ + "static/media/historial_venta.7886423a.svg";